export const EXERCISE_SCHEMA = "exercise/v1"

export function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value)
}

export function nonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0
}

export function langValue(value) {
  return isPlainObject(value) && nonEmptyString(value.text)
}

export function validateEnvelope(exercise, knownTypes = []) {
  if (!isPlainObject(exercise)) {
    return { code: "invalid_document", message: "Exercise must be an object" }
  }

  if (exercise.schema !== EXERCISE_SCHEMA) {
    return { code: "unsupported_schema", message: `Expected schema ${EXERCISE_SCHEMA}` }
  }

  if (!nonEmptyString(exercise.id)) {
    return { code: "missing_id", message: "Exercise id is required" }
  }

  if (!nonEmptyString(exercise.type) || !knownTypes.includes(exercise.type)) {
    return { code: "unknown_type", message: `Unsupported exercise type: ${exercise.type}` }
  }

  if (!Array.isArray(exercise.items)) {
    return { code: "invalid_items", message: "Exercise items must be an array" }
  }

  if (exercise.items.length === 0) {
    return { code: "empty_items", message: "Exercise has no items" }
  }

  if (exercise.config !== undefined && !isPlainObject(exercise.config)) {
    return { code: "invalid_config", message: "Exercise config must be an object" }
  }

  return null
}
